import http from "../shared/axios";
import { Lead_kyc_address_fetch, ekyc_redirect_encrypted_req, ekyc_redirect_decrypted_req, CKYC_OTP_Gen, CKYC_OTP_Verify } from "../shared/ServiceCommonEndpoints";
import { getApiReqHeaders } from "../shared/utility";
class KycSelectService {
  funcGetEkycAddress(payload){
        const headers = getApiReqHeaders(payload.data.applicationNumber); 
        return http.post(Lead_kyc_address_fetch, payload, { headers }).then(res => res.data);
  }

  funcEkycRedirectEncryptedReqParam(payload){
        const headers = getApiReqHeaders(payload.data.urnNo); 
        return http.post(ekyc_redirect_encrypted_req, payload, { headers }).then(res => res.data);
  }
  funcEkycRedirectDecryptedReqParam(payload){
      const headers = getApiReqHeaders(localStorage.getItem("applicationNumber")); 
      return http.post(ekyc_redirect_decrypted_req, payload, { headers }).then(res => res.data);
}
      funcCkycOtpGen(payload,resendFlag) {
            const reqPayload = {
                  data :{
                        applicationNumber: payload.applicationNumber , 
                        mobileNumber : payload.mobileNumber , 
                        ckycNo : payload.ckycNo
                  },
                  action : "submit",
                  type: "send-ckyc-otp"
            }
            if(resendFlag){
            reqPayload.data.resendFlag = "Y"; 
            }
            return http.post(CKYC_OTP_Gen, reqPayload,
            {
                  headers: {
                        "IDENTIFIER_1": localStorage.getItem("applicationNumber"),
                        "IDENTIFIER_2": localStorage.getItem("visitorID"),
                        "ENCRYPTED_ID": "1"
                  }
            }
            );
      }

      funcvalidateCKycOTP(payload) {
            const headers = getApiReqHeaders(payload.applicationNumber);
            const otpInputData = {
                  data : payload,
                  "action": "submit",
                  "type": "verify-ckyc-otp"
            };
            return http.post(CKYC_OTP_Verify, otpInputData,{ headers }).then(res => res.data);
      }
}
// eslint-disable-next-line
export default new KycSelectService();
